import React from 'react';
import type ProjectSettingsServiceDeskSlaSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-sla-settings/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskSlaSettings = lazyForPaint<
	typeof ProjectSettingsServiceDeskSlaSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-sla-settings", jiraSpaEntry: "async-project-settings-service-desk-sla-settings" */ '@atlassian/jira-spa-apps-project-settings-service-desk-sla-settings'
		),
	),
);

export const ServiceDeskSlaSettings = (): React.JSX.Element => (
	<UFOSegment name="project-settings-service-desk-sla-settings">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskSlaSettings}
			pageId="project-settings-service-desk-sla-settings"
			shouldShowSpinner
		/>
	</UFOSegment>
);
